<app-smart-collect *ngIf="english"></app-smart-collect>
<app-smart-collect-hindi *ngIf="hindi"></app-smart-collect-hindi>